import {
	Component,
	Input,
	ViewEncapsulation,
	Output,
	EventEmitter
} from '@angular/core';

/**
 * This component is a custom HTML No Data component.
 * It has several built-in features such as support for icons, predefined styles,
 * different button types, different button sizes, and UI customization.
 * To use this button component import FnButtonModule in Module.
 */
@Component({
	selector: 'fn-no-data-box',
	templateUrl: 'fn-no-data-box.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class FnNoDataBoxComponent {
	@Input() showImg = false;
	@Input() showDesc = false;
	@Input() imgContainerheight = '';
	@Input() headerTitle = 'No Data to  Display';
	@Input() description =
		"It's look like you have nothing to display. You can add some valuable data just by clicking on Add/Update button.";
	@Input() imgPath =
		'https://agcdn.altametrics.com/hubworks_resources/pre_dev/images/common/no_data_display.svg';
	@Input() isVerticalImg = true;
	@Input() showAddBtn = false;
	@Output() addActionCB = new EventEmitter();

	addAction() {
		this.addActionCB.emit();
	}
}
